import { render, staticRenderFns } from "./income-history-section.vue?vue&type=template&id=7ec6945c&scoped=true"
import script from "./income-history-section.vue?vue&type=script&lang=ts"
export * from "./income-history-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec6945c",
  null
  
)

export default component.exports